import { createEntityAdapter } from '@reduxjs/toolkit';

import type { SavedAddress } from './addresses.types';

const addressesAdapter = createEntityAdapter<SavedAddress>({
  selectId(a) {
    return a.addressid;
  },
});

export default addressesAdapter;
